import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    button: {
      ...theme.typography.medium12,
      flex: 1,
      height: 32,
      backgroundColor: COLORS.gray.gray90,
      color: COLORS.primary.default,
      '&:hover': {
        backgroundColor: COLORS.primary.silver,
        color: COLORS.primary.default,
      },
    },
    buttonOutlined: {
      border: 'none',
      backgroundColor: COLORS.gray.gray90,

      '&:hover': {
        border: 'none',
        backgroundColor: COLORS.primary.silver,
      },
    },
  }),
  { name: 'PersonaTooltipContent' }
);
